import React from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Box,
  Typography,
} from '@mui/material'

import { TASK_STATUS_TYPES, TASK_TYPES } from '../../constants'
import { addTimezoneOffsetToTimestamp } from '../../utils/date'
import { grey } from '@mui/material/colors'

const GenericTaskModal = ({
  isOpen,
  onCloseModal,
  onSave,
  isEditing,
  note,
  date,
  setDate,
  setNote,
}) => {
  const handleClose = () => onCloseModal()

  const dateDisplay = addTimezoneOffsetToTimestamp(
    new Date(date)
  ).toLocaleDateString()

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth={'md'}>
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          General Task
          {isEditing && (
            <Button
              variant={'contained'}
              onClick={() => onSave(TASK_TYPES.GENERAL, TASK_STATUS_TYPES.DONE)}
            >
              Mark done
            </Button>
          )}
        </Box>
      </DialogTitle>
      <DialogContent>
        <TextField
          sx={{ mt: 2 }}
          label={'Change date'}
          type={'date'}
          margin='dense'
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          value={date}
          onChange={(e) => {
            setDate(e.target.value)
          }}
        ></TextField>
        <Typography
          sx={{ fontStyle: 'italic', fontSize: '14px', color: grey[800] }}
        >
          Use the input above to change the date.
        </Typography>

        <TextField
          onChange={(e) => setNote(e.target.value)}
          value={note}
          margin='dense'
          label={'Note'}
          fullWidth
          multiline
          rows={4}
        ></TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{isEditing ? 'Close' : 'Cancel'}</Button>

        <Button
          onClick={() =>
            onSave(TASK_TYPES.GENERAL, TASK_STATUS_TYPES.NOT_STARTED)
          }
          color={'primary'}
          variant={isEditing ? 'outlined' : 'contained'}
        >
          {isEditing ? 'Save' : `Create Task for ${dateDisplay}`}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default GenericTaskModal
